module.exports = __webpack_public_path__ + "img/thumbs-down.76c1523f.svg";